import { render } from "./RegisterVerifyView.vue?vue&type=template&id=0ac0f6d1&scoped=true"
import script from "./RegisterVerifyView.vue?vue&type=script&lang=js"
export * from "./RegisterVerifyView.vue?vue&type=script&lang=js"

import "./RegisterVerifyView.vue?vue&type=style&index=0&id=0ac0f6d1&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac0f6d1"]])

export default __exports__